import React, { useEffect } from 'react'
import AdminSidebar from '@components/admin/AdminSidebar'
import BaseTable from '@components/shared/BaseTable'
import { Link } from 'react-router-dom'
import 'twin.macro'
import { QueryFunctionContext, useQuery, useQueryClient } from 'react-query'
import { api } from '@api/index'
import usePagenation from '@hooks/usePagenation'
import EventPriorityChangeButton from '@components/admin/EventPriorityChangeButton'
import uuid from 'react-uuid'
import AddEventModal from '@components/admin/AddEventModal'
import useModal from '@hooks/useModal'
import EditEventModal from '@components/admin/EditEventModal'

const rowSize = 8

const fetchEventList = ({ queryKey }: QueryFunctionContext) => {
  const [_, page] = queryKey
  return api.adminService.getEventList({
    size: rowSize,
    page: (page as number) - 1,
    sort: 'priority,desc',
  })
}

const AdminEventManagement = () => {
  const queryClient = useQueryClient()
  const [openEventModal] = useModal({ reactQuery: true })
  const [openResModal] = useModal()

  const {
    pagelist,
    currentPage,
    goFirstSection,
    goBeforeSection,
    goNextSection,
    goNext,
    goBefore,
    setListRefIndex,
    setTotalPage,
  } = usePagenation(5)

  const {
    isLoading,
    error,
    data: { totalPages, content } = {} as EventPagenationInfo,
  } = useQuery(['EventList', currentPage], fetchEventList, {
    refetchOnWindowFocus: false,
  })

  const handleEventAdd = async () => {
    const modalRes = await openEventModal(<AddEventModal />)
    if (modalRes) {
      queryClient?.invalidateQueries(['EventList', 1])
      setListRefIndex(0)
      goFirstSection()
    }
  }

  const handleEventListRowClick = async (e: React.MouseEvent, uuid: number) => {
    const event = content.find((it) => it.id == uuid) as EventInfo
    const modalRes = await openEventModal(<EditEventModal event={event} />)
    if (modalRes) {
      queryClient?.invalidateQueries(['EventList', 1])
      setListRefIndex(0)
      goFirstSection()
    }
  }

  return (
    <>
      <section tw="w-1200 flex gap-32">
        <AdminSidebar />
        <main tw="w-full">
          <h1 tw="text-2xl border-b-2 font-bold pb-10 border-neutral-400">
            이벤트관리
          </h1>
          <div tw="flex justify-end items-center gap-12 mt-20">
            <button className="button base" onClick={handleEventAdd}>
              추가
            </button>
          </div>
          <div tw="py-20">
            <BaseTable
              column={[
                ['번호', 5],
                ['제목', 5],
                ['url', 4],
                ['순서 변경', 4],
              ]}
            >
              {content?.map(({ id, title, url }) => (
                <tr
                  onClick={(e) => handleEventListRowClick(e, id)}
                  key={id}
                  tw="cursor-pointer hover:bg-neutral-200"
                >
                  <td>{id}</td>
                  <td>{title}</td>
                  <td>{url}</td>
                  <td>
                    <EventPriorityChangeButton
                      currentPageIdx={currentPage}
                      eventId={Number(id)}
                      key={uuid()}
                    />
                  </td>
                </tr>
              ))}
            </BaseTable>
          </div>
          <div tw="w-full flex justify-center gap-8 mt-15">
            {' '}
            <button
              type="button"
              className="button base"
              onClick={goBeforeSection}
            >
              {'<<'}
            </button>
            <button type="button" className="button base" onClick={goBefore}>
              {'<'}
            </button>
            {pagelist.map((num, idx) => (
              <button
                type="button"
                className="button base"
                onClick={() => setListRefIndex(idx)}
                key={num}
              >
                {num}
              </button>
            ))}
            <button type="button" className="button base" onClick={goNext}>
              {'>'}
            </button>
            <button
              type="button"
              className="button base"
              onClick={goNextSection}
            >
              {'>>'}
            </button>
          </div>
        </main>
      </section>
    </>
  )
}

export default AdminEventManagement
